<ras-page>
	<main>
		<h1>Contact us</h1>

		<p class="lead">Whether you're looking for more information or want to send us your valued feedback, we'd like to hear from you.</p>

		<form [ngClass]="{'show-invalid': show_invalid}" id="contact-form">

			<h2>Send enquiry online</h2>

			<p>
				<label class="required">Storage location</label>
				<ras-dropdown [options]="locations" label="display_name" [(value)]="location" [valid]="!show_invalid || !!location"></ras-dropdown>
				<span class="validation" *ngIf="show_invalid && !location">Please choose a location</span>
			</p>
			<p>
				<label>First Name</label>
				<input name="name" [(ngModel)]="name" type="text">
			</p>
			<p>
				<label>Surname</label>
				<input name="surname" [(ngModel)]="surname" type="text" type="text">
			</p>
			<p>
				<label class="required">Cell</label>
				<input name="cell" [(ngModel)]="cell" type="text" type="text" [ngClass]="{invalid: !valid.sa_cell_number(cell)}">
				<span class="validation" *ngIf="show_invalid && !valid.sa_cell_number(cell)">Please provide a valid SA cell number</span>
			</p>
			<p>
				<label class="required">Email</label>
				<input name="email" [(ngModel)]="email" type="text" type="text" [ngClass]="{invalid: !valid.email(email)}">
				<span class="validation" *ngIf="show_invalid && !valid.email(email)">Please provide an email address</span>
			</p>
			<p>
				<button type="button" (click)="send_message()">Submit</button>
			</p>

		</form>

		<div>

			<h2>Enquiries</h2>

			<h3>For storage rentals</h3>
			<a href="tel:0861736827">0861 73 68 27</a>


			<h2>Locations</h2>

			<div class="row three-cols">
				<div class="col">
					<h3>Midrand & HQ</h3>
					<p>
						Cnr. K101 &
						<br>Johnnic Blvd,
						<br>Midrand,
						<br>1685
					</p>
				</div>
<!-- 				<div class="col">
					<h3>East Rand</h3>
					<p>
						Cnr. Atlas Road and Caro Nome Road,
						<br>Bonaero Park,
						<br>East Rand,
						<br>1619
					</p>
				</div> -->
				<div class="col">
					<h3>Sandton</h3>
					<p>
						805 Pretoria Main
						<br>Service Road,
						<br>Sandton,
						<br>2090
					</p>
				</div>
				<div class="col">
					<h3>Centurion</h3>
					<p>
						Venter Road,
						<br>Heuweloord,
						<br>Centurion,
						<br>0157
					</p>
				</div>
				<div class="col">
					<h3>Honeydew</h3>
					<p>
						Cnr Botma Street
						<br>and Deysel Road
						<br>Honeydew
					</p>

				</div>
				<div class="col">
					<h3>Pretoria, Roseville</h3>
					<p>
						Cnr. D F Malan Drive
						<br>and Reigers Avenue,
						<br>Roseville
					</p>
				</div>
					<div class="col">
					<h3>Pretoria, Hatfield</h3>
					<p>
						1250 Pretorius street,
						<br>Hatfield
					</p>
				</div>
			</div>


			<h2>Customer care</h2>

			<p>We are committed to providing the highest level of service. If you have not experienced the service and facility excellence that you would expect from Rent-A-Store, we’d like to fix this! Log your complaint at: <a [routerLink]="['/vip']">rentastore.co.za/vip</a></p>

			<h2>Business development</h2>

			<div class="row three-cols">
				<div class="col">
					<h3>Tel:</h3>
					<a href="tel:0118058339">011 805 8339</a>
				</div>

				<div class="col">
					<h3>Address:</h3>
					<p>
						CNR K101 & Johnnic Bvd,
						<br>Gauteng,
						<br>South Africa
					</p>
				</div>

				<div class="col">
					<h3>Postal:</h3>
					<p>
						P O BOX 948,
						<br>Midrand,
						<br>1685,
						<br>Gauteng,
						<br>South Africa
					</p>
				</div>
			</div>
		</div>
	</main>
</ras-page>

<ras-spinner [active]="busy"></ras-spinner>

<ras-popup *ngIf="form_sent" (close)="form_sent = false">
	<p>Thank you for contacting us. A consultant will call you.</p>
</ras-popup>

<ras-popup *ngIf="form_error" (close)="form_error = false" [error]="true">
	<p>Thank you for contacting us. Unfortunately we seem to be experiencing technical difficulties at the moment. Please try again later, or call us on 0861{{'&nbsp;'}}73{{'&nbsp;'}}68{{'&nbsp;'}}27.</p>
</ras-popup>
